import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AppState from "../model/AppState";
import ListaModel from "../model/ListaModel";
import NavegadorUtil from "../util/NavegadorUtil";
import UsuarioModel from "../model/UsuarioModel";
import { FormControl } from "@material-ui/core";
import ObaTextField from "./ObaTextField";
import NavegadorAcaoEnum from "../util/NavegadorAcaoEnum";
import LojaModel from "../model/LojaModel";
import ProxyMensagemDAO from "../dataAccess/Proxy/ProxyMensagemDAO";
import Carregando from "./Carregando";

type ModalFeedbackProps = {
  toggleModalFeedback: any;
};

type ModalFeedbackState = {
  showNovaFeedbakForm: boolean;
  listas: ListaModel[];
  usuarioLogado: UsuarioModel;
  nome: string;
  email: string;
  assunto: string;
  mensagem: string;
  carregando: boolean;
  concluido: boolean;
};

class ModalFeedback extends React.Component<ModalFeedbackProps, any> {
  constructor(props: ModalFeedbackProps) {
    super(props);
    this.showFeedbackForm = this.showFeedbackForm.bind(this);
    this.setNome = this.setNome.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setAssunto = this.setAssunto.bind(this);
    this.setMensagem = this.setMensagem.bind(this);
    this.saveFeedback = this.saveFeedback.bind(this);

    this.state = {
      showNovaFeedbakForm: false,
      listas: [],
      carregando: false,
      concluido: false,
      assunto: "Feedback enviado pelo webapp",
    };
  }

  componentDidMount(): any {
    const logado: UsuarioModel | null = AppState.getUsuarioLogado();
    if (logado) {
      this.setState({
        nome: logado.nome,
        email: logado.email,
        usuarioLogado: logado,
      });
    }
  }

  showFeedbackForm(): void {
    this.setState({ showFeedbackForm: !this.state.showFeedbackForm });
  }

  async saveFeedback(): Promise<void> {
    const { nome, email, assunto, mensagem } = this.state;

    if (
      !nome ||
      !email ||
      !mensagem ||
      (nome.trim().length === 0) ||
      (email.trim().length === 0) ||
      (mensagem.trim().length === 0)) {
        NavegadorUtil.alerta(
          this,
          "Favor preencher o campo nome, email e mensagem.",
          "alerta-msg-ajuda",
          NavegadorAcaoEnum.NAV_UTIL_ALERTA_MENSAGEM_NAO_PREENCHIDO,
          ""
        );
    } else {
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      if (loja) {
        this.setState({ carregando: true });
        const emailMensagem = `Nome: ${nome}
Email: ${email}
Mensagem: ${mensagem}`;

        ProxyMensagemDAO.getInstance()
          .sendMensagem(loja, assunto, emailMensagem)
          .then((e) => {
            this.setState({ carregando: false, concluido: true });
            NavegadorUtil.alerta(this, e.data.message);
            this.props.toggleModalFeedback();
          })
          .catch((e) => {
            this.setState({ carregando: false, concluido: true });
            NavegadorUtil.alerta(this, e.data.message);
            this.props.toggleModalFeedback();
          });
      }
    }
  }

  setNome(nome: string): void {
    this.setState({
      nome,
    });
  }

  setEmail(email: string): void {
    this.setState({
      email,
    });
  }

  setAssunto(assunto: string): void {
    this.setState({
      assunto,
    });
  }

  setMensagem(mensagem: string): void {
    this.setState({
      mensagem,
    });
  }

  render(): any {
    const { nome, email, mensagem, concluido } = this.state;

    const fieldWidth: number = 250;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 30,
    };

    return (
      <Dialog open={true}>
        <DialogContent>
          <div className="modal" id="lists-modal">
            <p className="title">O que você achou?</p>
            <p className="subtitle">
              Envie uma mensagem para a nossa central de atendimento, nos conte como foi sua experiência e retornaremos assim que possível.<br/>
              Sua opinião é muito importante para nós.<br/>
              <b>ATENÇÃO:</b> Para questões emergenciais, como inclusão ou exclusão de seu pedido, recomendamos que ligue em nossa loja e fale com um de nossos atendentes.<br/>
            </p>
            <div className="assuntoMensagem">
              <FormControl variant="outlined" style={objStyle}>
                <ObaTextField
                  onChange={(e) => this.setNome(e.target.value as string)}
                  style={{ width: fieldWidth }}
                  inputProps={{
                    name: "nome",
                    id: "nome",
                  }}
                  variant="outlined"
                  label="Nome"
                  error={!nome || nome.length === 0}
                  value={nome}
                />
              </FormControl>
              <FormControl variant="outlined" style={objStyle}>
                <ObaTextField
                  onChange={(e) => this.setEmail(e.target.value as string)}
                  style={{ width: fieldWidth }}
                  inputProps={{
                    name: "email",
                    id: "email",
                  }}
                  variant="outlined"
                  label="E-mail"
                  error={!email || email.length === 0}
                  value={email}
                />
              </FormControl>
              <FormControl variant="outlined" style={objStyle}>
                <ObaTextField
                  multiline
                  rows="4"
                  onChange={(e) => this.setMensagem(e.target.value as string)}
                  style={{ width: fieldWidth }}
                  inputProps={{
                    name: "mensagem",
                    id: "mensagem",
                  }}
                  variant="outlined"
                  label="Mensagem"
                  error={!mensagem || mensagem.length === 0}
                  value={mensagem}
                />
              </FormControl>
            </div>
            <div className="menu">
              <button onClick={this.props.toggleModalFeedback}>Cancelar</button>
              <button onClick={this.saveFeedback}>Enviar</button>
            </div>
          </div>
        </DialogContent>
        <Carregando exibir={this.state.carregando} concluido={concluido} />
      </Dialog>
    );
  }
}

export default ModalFeedback;
